module.exports = __webpack_public_path__ + "324c328d9f9610acbd46b6ae9d6fd01a.pdf";